export const CFDI4_REGIME_USE_MAP = {
   '605': ['S01'],
   '606': ['G03'],
   '607': ['S01'],
   '608': ['S01'],
   '610': ['S01'],
   '611': ['S01'],
   '612': ['G03'],
   '625': ['G03'],
   '614': ['S01'],
   '615': ['S01'],
   '616': ['S01'],
   '621': ['G03'],
   '626': ['G03'],
   '601': ['G03'],
   '603': ['G03'],
   '620': ['G03'],
   '622': ['G03'],
   '623': ['G03'],
   '624': ['G03'],
};
